// PURPOSE: Only for providing a background to change color
// FUNCTION: None

import React from "react";
import "../styles/Color.css";

const Color = () => {
    return <div className="background"></div>;
};

export default Color;
